import { FormBase } from 'core/components';

export default class ImportReferenceEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'IMPORT_REFERENCE.EDIT.NAME_LABEL',
                    placeholder: 'IMPORT_REFERENCE.EDIT.NAME_PLACEHOLDER',
                    rules: ['string', 'max:50', 'required'],
                },
                {
                    name: 'description',
                    label: 'IMPORT_REFERENCE.EDIT.DESCRIPTION_LABEL',
                    placeholder: 'IMPORT_REFERENCE.EDIT.DESCRIPTION_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'insuranceId',
                    label: 'IMPORT_REFERENCE.EDIT.INSURANCE_LABEL',
                    placeholder: 'IMPORT_REFERENCE.EDIT.INSURANCE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'importReferenceTypeId',
                    label: 'IMPORT_REFERENCE.EDIT.IMPORT_REFERENCE_TYPE_LABEL',
                    placeholder: 'IMPORT_REFERENCE.EDIT.IMPORT_REFERENCE_TYPE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'isBillableToMedicare',
                    type: 'bool',
                    rules: 'required',
                    value: false
                },
               {
                    name: 'isActive',
                    type: 'bool',
                    rules: 'required',
                    value: false
                },
            ],
        };
    }
}
